import projectDetail from './projectDetail';

export default projectDetail;
